import { Link } from "react-router-dom";
import type { Story } from "@/mocks/stories";
import { columnName } from "@/lib/content";

interface Props {
  story: Story;
  compact?: boolean;
  showExcerpt?: boolean;
}

export default function StoryCard({ story, compact = false, showExcerpt = true }: Props) {
  return (
    <article className="group flex h-full flex-col overflow-hidden rounded-xl border border-background-200/70 bg-background-100">
      <Link
        to={`/story/${story.slug}`}
        className="relative block overflow-hidden"
        aria-label={story.title}
        title={`${story.title} - 大学吃瓜`}
      >
        <div className="aspect-[16/10] w-full overflow-hidden">
          <img
            src={story.cover}
            alt={story.title}
            title={`${story.title} - 大学吃瓜`}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
        </div>
        <span className="absolute left-3 top-3 rounded-full bg-primary-500/90 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
          {columnName(story.column)}
        </span>
      </Link>

      <div className="flex flex-1 flex-col p-4 md:p-5">
        <h3 className="font-heading text-[15px] font-bold leading-snug text-foreground-950 md:text-base">
          <Link to={`/story/${story.slug}`} className="transition-colors hover:text-primary-700" title={story.title}>
            {story.title}
          </Link>
        </h3>
        {showExcerpt && !compact && (
          <p className="mt-2 line-clamp-2 text-sm leading-6 text-foreground-600">{story.summary}</p>
        )}
        <div className="mt-auto flex items-center justify-between pt-4 text-xs text-foreground-500">
          <span className="flex items-center gap-1.5">
            <i className="ri-time-line" aria-hidden="true" />
            {story.date}
          </span>
          <span className="flex items-center gap-3">
            <span className="flex items-center gap-1">
              <i className="ri-eye-line" aria-hidden="true" /> {story.views}
            </span>
            <span className="flex items-center gap-1 text-primary-600">
              <i className="ri-fire-line" aria-hidden="true" /> {story.heat}.0
            </span>
          </span>
        </div>
      </div>
    </article>
  );
}